import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { format } from "date-fns";
import { Clock, MapPin } from "lucide-react";

interface VehicleCollectionConfirmationSummaryProps {
  selectedDate: Date | undefined;
  isTimeSelected: boolean;
  depot?: {
    name: string;
    address: string;
    city: string;
  };
}

const VehicleCollectionConfirmationSummary: React.FC<
  VehicleCollectionConfirmationSummaryProps
> = ({ selectedDate, isTimeSelected, depot }) => {
  if (!selectedDate || !isTimeSelected) {
    return null;
  }

  return (
    <Card className="bg-green-50 border-green-200">
      <CardContent className="pt-6">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Clock className="w-4 h-4 text-green-600" />
          </div>
          <div className="space-y-2">
            <h3 className="font-semibold text-green-900">
              Your Vehicle Collection Confirmed
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <span className="font-medium text-green-800">Date & Time:</span>
                <p className="text-green-700">
                  {format(selectedDate, "EEEE, MMMM d, yyyy")} at{" "}
                  {format(selectedDate, "h:mm a")}
                </p>
              </div>
              <div>
                <span className="font-medium text-green-800 flex items-center gap-1">
                  <MapPin className="w-3 h-3" />
                  Location:
                </span>
                <p className="text-green-700">
                  {depot
                    ? `${depot.name}, ${depot.address}, ${depot.city}`
                    : "HIVED Operations Center"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default VehicleCollectionConfirmationSummary;
